import { render, staticRenderFns } from "./ShopInventory.vue?vue&type=template&id=5e62e038&scoped=true"
import script from "./ShopInventory.vue?vue&type=script&lang=js"
export * from "./ShopInventory.vue?vue&type=script&lang=js"
import style0 from "./ShopInventory.vue?vue&type=style&index=0&id=5e62e038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e62e038",
  null
  
)

export default component.exports